import React, { useState } from 'react';
import './CookieWidget.css';

function CookieWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Bottone flottante rotondo in basso a sinistra */}
      <button 
        type="button"
        className="cookie_floating_btn" 
        onClick={() => setIsOpen(true)}
        title="Gestione Cookie & Privacy"
        aria-label="Gestione Cookie"
      >
        🍪
      </button>

      {/* Finestra modale che si apre al clic */}
      {isOpen && (
        <div className="cookie_modal_overlay" onClick={() => setIsOpen(false)}>
          <div className="cookie_modal_box" onClick={(e) => e.stopPropagation()}>
            <div className="cookie_modal_header">
              <h3>Preferenze Cookie & Note Legali</h3>
              <button 
                type="button" 
                className="cookie_modal_close" 
                onClick={() => setIsOpen(false)}
              >
                &times;
              </button>
            </div>

            <div className="cookie_modal_body">
              <p>
                Questo sito utilizza cookie tecnici essenziali per garantire il corretto funzionamento delle sessioni e degli acquisti.
              </p>
              <p>
                Per consultare l'informativa completa su come gestiamo i tuoi dati e i cookie, leggi il nostro documento ufficiale:
              </p>
              
              {/* Sostituisci il link con la route o il file del tuo documento */}
              <div className="cookie_modal_links">
                <a 
                  href="/cookie-policy/Cookie_Policy_TOTAL_SERVICE_SRL.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="cookie_link_btn"
                >
                  📄 Consulta la Cookie Policy
                </a>
              </div>
            </div>

            <div className="cookie_modal_footer">
              <button 
                type="button" 
                className="cookie_confirm_btn"
                onClick={() => setIsOpen(false)}
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CookieWidget;